const EntryService = require('../services/EntryService').default;
const getSpace = require('./contentful/get-space');
const transformer = require('./transformers/leadSchema');
const processError = require('./contentful/error-process');
const entryCreate = require('./contentful/entry-create');

let entryService = null;

const gettingEntryService = () => {
  if (!entryService) {
    entryService = getSpace().then((space) => {
      return new EntryService(space, transformer);
    });
  }

  return entryService;
};

module.exports = {
  getAll() {
    return getSpace().then((space) => {
      const params = {
        'content_type': 'leadSchema',
        'order': '-sys.updatedAt',
        'sys.archivedAt[exists]': false,
        'limit': 999
      };

      return space
        .getEntries(params)
        .catch(processError)
        .then((response) => {
          const data = response.toPlainObject();
          return data.items.map(transformer.contentfulToInternal);
        });
    });
  },

  getById(...parameters) {
    return gettingEntryService().then((service) =>
      service.getById(...parameters)
    );
  },

  publish(...parameters) {
    return gettingEntryService().then((service) => service.publish(...parameters));
  },

  unpublish(...parameters) {
    return gettingEntryService().then((service) => service.unpublish(...parameters));
  },

  archive(...parameters) {
    return gettingEntryService().then((service) => service.archive(...parameters));
  },

  createEmpty() {
    return {
      name: '',
      type: null,
      items: []
    };
  },

  save(schema) {
    if (schema.id) {
      return gettingEntryService().then((service) => service.save(schema));
    }

    const data = transformer.internalToContentful(schema);
    return getSpace().then((space) => (entryCreate(space, 'leadSchema', data).then(transformer.contentfulToInternal)));
  }
};
